module.exports = __webpack_public_path__ + "mou.c08b00b42d8110bf6721c954f697cdc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/mou.svg
// module id = 337
// module chunks = 0